/**
 * EVUS 查询 API 服务
 * 与后端 /api/evus/query 端点通信
 */

export async function startEvusQuery(payload) {
  const resp = await fetch('/api/evus/query/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || `查询启动失败: ${resp.status}`);
  }
  return data;
}

export async function getEvusStatus(taskId) {
  const resp = await fetch(`/api/evus/query/status/${encodeURIComponent(taskId)}`);

  if (resp.status === 404) return null;

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || `获取状态失败: ${resp.status}`);
  }
  return data;
}
